
export class DashboardTabIndexKey {
  public static readonly tabIndex: string = 'tabIndex';
}
